var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('menu-button');
import { breakpoints, theme } from '@shapeable/theme';
import { DottedHamburgerIcon } from './dotted-hamburger-icon';
export var MenuButtonDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    cursor: pointer;\n  "], ["\n    ", ";\n    cursor: pointer;\n  "])), theme.REMOVE_BUTTON_STYLE())
});
var IconStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 24px;\n    cursor: pointer;\n  "], ["\n    width: 24px;\n    cursor: pointer;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(DottedHamburgerIcon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var MenuButton = function MenuButton(props) {
  var className = props.className,
      onClick = props.onClick;
  return React.createElement(My.Container, {
    onClick: onClick,
    type: "button",
    className: cls.name(className)
  }, React.createElement(My.Icon, null));
};
MenuButton.defaultProps = MenuButtonDefaultProps;
MenuButton.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;